"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateStandardConcentrationLimitKickouts = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
const normalizeConcentrationLimit = ({ concentrationLimit, totalConcentrationExposure, }) => Math.min(lodash_1.default.round(common_1.utils.divideByOrZero(concentrationLimit, totalConcentrationExposure), 10), 1);
const getNormalizedConcentrationLimit = ({ concentrationLimitValueType, concentrationLimit, totalConcentrationExposure, }) => {
    switch (concentrationLimitValueType) {
        case 'currency':
        case 'number':
            return normalizeConcentrationLimit({
                concentrationLimit,
                totalConcentrationExposure,
            });
        case 'percentage':
            return concentrationLimit;
        default:
            return (0, common_1.finleyAssertUnreachable)(concentrationLimitValueType);
    }
};
const getConcentrationLimitKickouts = ({ concentrationFactor, concentrationReceivables, }) => {
    const receivableKickoutMap = {};
    for (const receivable of concentrationReceivables) {
        const { finleyReceivableId, concentrationLimitFields } = receivable;
        const kickout = lodash_1.default.round(concentrationLimitFields.eligibleExposureLessConcentrationLimitKickouts *
            concentrationFactor, 10);
        receivableKickoutMap[finleyReceivableId] = kickout;
    }
    return receivableKickoutMap;
};
/**
 * For a given concentration limit, identify if any of the servicing tapes
 * exceeded the concentration limit
 *
 * for standard reductions, we take a % based reduction, to equally reduce
 * the borrowing base amount across all concentration receivables
 *
 * @param concentrationLimitReceivables the receivables that the concentration limit applies to
 * @param totalEligibleExposure the total eligible exposure, to find adjustment percentage
 * @param concentrationLimit the concentration limit % of this property
 */
const calculateStandardConcentrationLimitKickouts = ({ concentrationReceivables, totalConcentrationExposure, concentrationLimit, concentrationLimitValueType, }) => {
    const normalizedConcentrationLimit = getNormalizedConcentrationLimit({
        concentrationLimit,
        concentrationLimitValueType,
        totalConcentrationExposure,
    });
    const concentrationAmount = lodash_1.default.sumBy(concentrationReceivables, ({ concentrationLimitFields }) => concentrationLimitFields.eligibleExposureLessConcentrationLimitKickouts);
    const exposureLimit = lodash_1.default.round(totalConcentrationExposure * normalizedConcentrationLimit, 10);
    // We'll multiply each loanTape by the concentration factor to get the
    // updated borrowing base amount
    const concentrationFactor = Math.max(concentrationAmount - exposureLimit, 0) > 0
        ? 1 - common_1.utils.divideByOrZero(exposureLimit, concentrationAmount)
        : 0;
    const kickouts = getConcentrationLimitKickouts({
        concentrationFactor,
        concentrationReceivables,
    });
    return {
        kickouts,
        calculations: {
            concentrationAmount,
            concentrationLimit: normalizedConcentrationLimit,
            concentration: lodash_1.default.round(common_1.utils.divideByOrZero(concentrationAmount, totalConcentrationExposure), 10),
        },
    };
};
exports.calculateStandardConcentrationLimitKickouts = calculateStandardConcentrationLimitKickouts;
//# sourceMappingURL=standard.js.map